// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__GhA9K","active":"Navigation_active__pohon"};